import { AHeaderProps } from '../../atoms/AHeader/AHeader.types';
import { ALinkStandaloneProps } from '../../atoms/ALinkStandalone/ALinkStandalone.types';

export enum MAccordionHeaderAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MAccordionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MAccordionHeaderAlignment;
  link?: boolean;
  aHeader: Partial<AHeaderProps>;
  aLinkStandalone?: Partial<ALinkStandaloneProps>;
}
